import {autoRegister, resolve} from "../../container";
import {promiseFromJsonResponse, promiseFromVoidResponse} from "../../common/utils/promises";
import {RequestSugarFactory} from "../common/requestSugar";
import {SecuredRequestExecutor} from "../../module/awswaf/securedRequestExecutor";

export type ChatResponse = {
    chatId: string;
    assistantMessageId?: string;
    assistantResponse?: string;
    outcome: string;
}

@autoRegister()
export class GptChatService {

    private basePath: string = "/enbw-eop/eop-app-gpt-chat/rest/stable/career-gpt";

    public constructor(private securedRequestExecutor: SecuredRequestExecutor = resolve(SecuredRequestExecutor)) {
    }

    public async createChat(configId: string, lang: string, message: string): Promise<ChatResponse> {
        const postRequest = (): Promise<Response> => fetch(
            `${this.basePath}/chats?configId=${configId}&lang=${lang}`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json;charset=UTF-8",
                    "EOP-Sugar": RequestSugarFactory.produce()
                },
                body: JSON.stringify({message})
            });
        const response = await this.securedRequestExecutor.execute(postRequest);
        return await promiseFromJsonResponse<ChatResponse>(response);
    }

    public async continueChat(chatId: string, message: string): Promise<ChatResponse> {
        const postRequest = (): Promise<Response> => fetch(
                `${this.basePath}/chats/${chatId}`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json;charset=UTF-8",
                        "EOP-Sugar": RequestSugarFactory.produce()
                    },
                    body: JSON.stringify({message})
                }
            )
        ;
        const response = await this.securedRequestExecutor.execute(postRequest);
        return await promiseFromJsonResponse<ChatResponse>(response);
    }

    public async addMessageReaction(chatId: string, messageId: string, reaction: boolean): Promise<void> {
        const rateRequest = (): Promise<Response> => fetch(
            `${this.basePath}/chats/${chatId}/messages/${messageId}/reactions`,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json;charset=UTF-8",
                    "EOP-Sugar": RequestSugarFactory.produce()
                },
                body: JSON.stringify({reaction})
            }
        );
        const response = await this.securedRequestExecutor.execute(rateRequest);
        return promiseFromVoidResponse(response);
    }

    public async addUserFeedback(chatId: string, messageId: string, feedback: string): Promise<void> {
        const rateRequest = (): Promise<Response> => fetch(
            `${this.basePath}/chats/${chatId}/messages/${messageId}/feedbacks`,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json;charset=UTF-8",
                    "EOP-Sugar": RequestSugarFactory.produce()
                },
                body: JSON.stringify({feedback})
            }
        );
        const response = await this.securedRequestExecutor.execute(rateRequest);
        return promiseFromVoidResponse(response);
    }
}